export const generateAvatarFromName = (name: string): string => {
  const initials = name.split(' ').map((n) => n.charAt(0)).join('').toUpperCase();
  return `https://ui-avatars.com/api/?name=${initials}&background=random`;
};
